export default __webpack_public_path__ + "static/media/apache_monitor.cfdf351e.md";